import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { NotificationProvider, useNotification } from './context/NotificationContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import NotificationBar from './components/NotificationBar/NotificationBar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

// Pages
import Home from './pages/Home/Home';
import AboutOverview from './pages/AboutOverview/AboutOverview';
import AboutProviders from './pages/AboutProviders/AboutProviders';
import Services from './pages/Services/Services';
import ServicesMedicationManagement from './pages/ServicesMedicationManagement/ServicesMedicationManagement';
import ServicesDeepTms from './pages/ServicesDeepTms/ServicesDeepTms';
import PatientForms from './pages/PatientForms/PatientForms';
import InsuranceInfo from './pages/InsuranceInfo/InsuranceInfo';
import NewPatient from './pages/NewPatient/NewPatient';
import PatientEducation from './pages/PatientEducation/PatientEducation';
import Contact from './pages/Contact/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import HipaaNotice from './pages/HipaaNotice/HipaaNotice';

import './App.scss';

const AppContent: React.FC = () => {
  const { currentMessage } = useNotification();
  
  return (
    <div className="app-container">
      <div className="page-wrapper">
        <NotificationBar />
        <Header />
        <main className={`app-main ${currentMessage && currentMessage.trim() !== '' ? 'with-notification' : ''}`}>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-overview" element={<AboutOverview />} />
            <Route path="/about-providers" element={<AboutProviders />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services-medication-management" element={<ServicesMedicationManagement />} />
            <Route path="/services-deep-tms" element={<ServicesDeepTms />} />
            <Route path="/patient-forms" element={<PatientForms />} />
            <Route path="/insurance-info" element={<InsuranceInfo />} />
            <Route path="/new-patient" element={<NewPatient />} />
            <Route path="/patient-education" element={<PatientEducation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/hipaa-notice" element={<HipaaNotice />} />
          </Routes>
        </main>
      </div>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <NotificationProvider>
      <AppContent />
    </NotificationProvider>
  );
};

export default App;

